/**
 * Terms of Service, English version.
 *
 * They describe what the application actually does, including what it does
 * NOT do. Promising less and delivering is the only way a document like this
 * is worth anything on the day it matters.
 */
export default {
    titulo: 'Terms of Service',
    actualizado: 'September 10, 2026',

    intro: [
        'By creating a ShippingFULL account you accept these terms. Read them: they are short, and some things are better known before rather than after.',
        'ShippingFULL is operated from New Jersey, United States.'
    ],

    secciones: [
        {
            titulo: '1. What ShippingFULL is',
            parrafos: [
                'A tool for searching supplier catalogues, evaluating products, publishing them to your store and tracking your orders.',
                '**It is a tool, not a seller or a middleman.** We do not buy, do not sell, do not hold stock, do not ship parcels and do not handle returns. All of that happens between you, your supplier and your buyer.'
            ]
        },
        {
            titulo: '2. Your account',
            parrafos: [
                'You must be 18 or older and give accurate details. You are responsible for your password and for what happens under your account.',
                'If you notice unauthorised use, write to **support@shippingfull.com** and change your password: doing so immediately invalidates every open session.'
            ]
        },
        {
            titulo: '3. What you are responsible for',
            parrafos: [
                'This is the important part, and the one that prevents the most trouble.',
                '**Each marketplace\u2019s rules are yours to follow, not ours.** eBay, for instance, forbids reselling on its platform anything bought from another marketplace. The application tries to help: it checks the source → destination pairing and will not let you publish what it knows is forbidden. But those rules are written by them, change without telling us, and **the seller account at stake is yours**.',
                'You are also responsible for the taxes, consumer obligations and data protection duties that apply where you operate, including what you owe to the buyers whose data passes through this application.'
            ]
        },
        {
            titulo: '4. What the application calculates, and what it is worth',
            parrafos: [
                'Product scores, profit estimates, pricing suggestions and artificial-intelligence analyses are **indicative**. They are calculated from data the suppliers publish, which may be incomplete or out of date.',
                'When a figure could not be verified, the application says so rather than filling it in: an incomplete score is marked incomplete, and an estimate is never presented as an artificial-intelligence judgement. Even so, **the decision to buy, publish or set a price is yours**, and no number in this application is financial advice.'
            ]
        },
        {
            titulo: '5. Third-party services',
            parrafos: [
                'To work, the application connects to eBay, CJ Dropshipping, Amazon, AliExpress, Stripe, Google and Anthropic, among others.',
                'Your relationship with each of them is governed by their own terms. If one changes its interface, raises its prices, limits its use or closes your account, **that is outside our control and we are not answerable for it**, though we will do what is reasonable to adapt.'
            ]
        },
        {
            titulo: '6. Subscriptions and payments',
            parrafos: [
                'There is a free plan with usage limits and a paid plan without them. Payments are processed by Stripe; we never see or store your card details.',
                'Subscriptions renew automatically until you cancel. You can cancel at any time from the application and you keep access until the end of the period already paid for.',
                'If a charge fails, we will tell you, and access to the paid plan may be suspended until it is settled.'
            ]
        },
        {
            titulo: '7. Acceptable use',
            parrafos: [
                'You may not use ShippingFULL for unlawful activity, to infringe anyone\u2019s rights, to list counterfeit or prohibited goods, or to attempt to reach data belonging to other accounts.',
                'Nor to query suppliers at a rate that degrades their service: the application respects the limits they impose, and working around them on your own can cost all of us access.'
            ]
        },
        {
            titulo: '8. Availability, without promises we cannot keep',
            parrafos: [
                'We do what is reasonable to keep the application running, but **we do not guarantee it will be available without interruption or free of errors**.',
                'It depends on services we do not control, and when one of them fails, some features stop working. In those cases the application says so on screen rather than faking a result.'
            ]
        },
        {
            titulo: '9. Limitation of liability',
            parrafos: [
                'To the extent the law allows, ShippingFULL is not liable for lost profits, lost data, suspension of your account on a marketplace, or indirect damages arising from use of the application.',
                'Our total liability, if any, will not exceed the amount you have paid us in the twelve months before the event giving rise to it.'
            ]
        },
        {
            titulo: '10. Termination',
            parrafos: [
                'You may stop using the application and close your account whenever you like.',
                'We may suspend an account that breaches these terms or puts the service at risk for others. If we do, we will tell you why.'
            ]
        },
        {
            titulo: '11. Changes to these terms',
            parrafos: [
                'If they change, we will update the date in the header and tell you inside the application when the change is significant. Continuing to use ShippingFULL afterwards means accepting them.'
            ]
        },
        {
            titulo: '12. Governing law',
            parrafos: [
                'These terms are governed by the laws of the State of **New Jersey, United States**, without regard to its conflict-of-laws rules.'
            ]
        },
        {
            titulo: '13. Contact',
            parrafos: [
                '**support@shippingfull.com**'
            ]
        }
    ]
};
